import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

const FilterBadge = ({ children, muted = false }) => {
  const theme = useTheme();

  return (
    <Box
      component="span"
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: "4px",
        fontSize: "0.75rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
        bgcolor: muted
          ? theme.palette.grey[200]
          : alpha(theme.palette.secondary.main, 0.15),
        color: muted
          ? theme.palette.text.secondary
          : theme.palette.secondary.dark,
      }}
    >
      {children}
    </Box>
  );
};

export default FilterBadge;
